import { Link } from "@tanstack/react-router";
import type { ReactNode } from "react";
import { NewsletterSignup } from "@/components/NewsletterSignup";

export const M = {
  BG: "var(--paper)",
  SURFACE: "var(--card)",
  INK: "var(--primary)",
  INK_SOFT: "var(--ink-secondary)",
  INK_FAINT: "var(--ink-tertiary)",
  BRASS: "var(--editorial-accent, var(--accent))",
  RULE: "var(--rule)",
  SERIF:
    '"Iowan Old Style", "Source Serif Pro", "Source Serif 4", "Charter", Georgia, ui-serif, serif',
};

const NAV = [
  { to: "/pricing", label: "Pricing" },
  { to: "/free-review", label: "Free review" },
  { to: "/blog", label: "Blog" },
  { to: "/faq", label: "FAQ" },
  { to: "/students", label: "Students" },
] as const;

export function MarketingShell({ children }: { children: ReactNode }) {
  return (
    <div className="min-h-screen" style={{ background: M.BG, color: M.INK }}>
      <header
        className="mx-auto flex max-w-6xl flex-wrap items-center justify-between gap-3 px-6 py-5 border-b"
        style={{ borderColor: M.RULE }}
      >
        <Link to="/" className="text-lg font-semibold" style={{ fontFamily: M.SERIF, color: M.INK }}>
          Tiger&apos;s Eye
        </Link>
        <nav className="flex flex-wrap items-center gap-4 text-sm">
          {NAV.map((n) => (
            <Link
              key={n.to}
              to={n.to}
              style={{ color: M.INK_SOFT }}
              activeProps={{ style: { color: M.INK, fontWeight: 600 } }}
            >
              {n.label}
            </Link>
          ))}
        </nav>
      </header>
      <main className="mx-auto max-w-3xl px-6 py-14">{children}</main>
      <div className="mx-auto max-w-3xl px-6 pb-14">
        <NewsletterSignup source="marketing" />
      </div>
      <footer
        className="mx-auto flex max-w-6xl flex-wrap items-center justify-between gap-3 px-6 pb-10 text-xs"
        style={{ color: M.INK_FAINT }}
      >
        <span>© {new Date().getFullYear()} Tiger&apos;s Eye · by PRAXIA</span>
        <span className="flex gap-4">
          <Link to="/versus" style={{ color: M.INK_SOFT }}>Vs AI writing tools</Link>
          <Link to="/terms" style={{ color: M.INK_SOFT }}>Terms &amp; ethos</Link>
        </span>
      </footer>
    </div>
  );
}
